import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { HighlightOffRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogTitle,
  Fade,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import { setCookieAcceptance } from 'src/redux/app/app-slice';

const CookieBanner = ({ dispatch }: DispatchProp) => {
  const [open, setOpen] = React.useState(true);

  const handleReject = () => {
    localStorage.setItem('userCookieSelectionChoice', 'false');
    dispatch(setCookieAcceptance(false));
  };

  const handleAccept = () => {
    localStorage.setItem('userCookieSelectionChoice', 'true');
    dispatch(setCookieAcceptance(true));
  };

  return (
    <Fade appear={false} in={open}>
      <Paper
        role="dialog"
        sx={{
          position: 'fixed',
          bottom: '50px',
          right: '50px',
          borderWidth: '1px',
          borderRadius: '5px',
          zIndex: 999,
          width: '470px',
          boxShadow: '0px 4px 10px 0px #00000040',
          color: '#11112b',
        }}
        tabIndex={-1}
      >
        <Box data-testid="cookie-banner">
          <DialogTitle sx={{ padding: '16px 32px' }}>
            <Stack direction="row" sx={{ alignItems: 'center' }}>
              <Typography sx={{ fontSize: '24px' }}>
                We Value your Privacy
              </Typography>
              <IconButton
                onClick={() => setOpen(false)}
                sx={{ color: '#11112B', marginLeft: 'auto' }}
              >
                <HighlightOffRounded />
              </IconButton>
            </Stack>
          </DialogTitle>
          <div
            style={{
              padding: '24px 32px',
              borderTop: '1px solid #dfe6ec',
              borderBottom: '1px solid #dfe6ec',
              backgroundColor: '#f9f8fd',
            }}
          >
            <Typography>
              We use cookies to enhance your browsing experience, serve
              personalized ads or content, and analyze our traffic. By clicking
              “Accept”, you consent to our use of cookies.
            </Typography>
          </div>
        </Box>
        <div>
          <Stack sx={{ padding: '16px 32px', gap: 2 }} direction="row">
            <Button
              onClick={() => handleReject()}
              sx={{
                borderColor: '#11112b',
                color: '#11112b',
                width: '175px',
                textTransform: 'none',
              }}
              variant="outlined"
            >
              Reject
            </Button>
            <Button
              color="primary"
              onClick={() => handleAccept()}
              sx={{ width: '175px', textTransform: 'none' }}
              variant="contained"
            >
              Accept
            </Button>
          </Stack>
        </div>
      </Paper>
    </Fade>
  );
};

export default connect()(CookieBanner);
